import React, { type FC, useState } from 'react'

import { Translation } from '../../../../domain'

import { FormattedTranslation } from '../../Internationalization'
import { Button } from '../Button'
import type { CalendarProps } from './Calendar'
import { DateTimeRangeChip } from './DateTimeRangeChip'
import { DateTimeRangePicker, type DateTimeRangeValue } from './DateTimeRangePicker'

type DateTimeRangeFilterProps =
    & Readonly<{
        value: DateTimeRangeValue
        onApply: (range: DateTimeRangeValue) => void
    }>
    & Pick<CalendarProps, 'disableAfter'>

export const DateTimeRangeFilter: FC<DateTimeRangeFilterProps> = ({ value: { start, end }, onApply, disableAfter }) => {
    const [isPickerOpen, setIsPickerOpen] = useState(false)

    const appliedRange = start ?? end ? { start, end } : undefined

    const handleApply = ({ start, end }: DateTimeRangeValue): void => {
        onApply({ start, end })
        setIsPickerOpen(false)
    }

    const handleClear = (): void => {
        onApply({ start: null, end: null })
    }

    return (
        <>
            <Button data-testid="time-button" size="medium" variant="secondary" onClick={() => setIsPickerOpen(true)}>
                <FormattedTranslation id={Translation.TIME} />
            </Button>

            {appliedRange && <DateTimeRangeChip value={appliedRange} onClear={handleClear} />}

            {isPickerOpen && (
                <DateTimeRangePicker
                    value={appliedRange}
                    onApply={handleApply}
                    onCancel={() => setIsPickerOpen(false)}
                    disableAfter={disableAfter}
                />
            )}
        </>
    )
}
